// react
import * as React from "react";
// material
import ActionHelpOutline from "material-ui/svg-icons/action/help-outline";
import IconButton from "material-ui/IconButton";
// global
import l10n = require("diy/util/l10n");

interface StepTextProps {
    title: string;
    description: string;
    showHelpIcon: boolean;
    onHelp?(): void;
}

export class StepText extends React.Component<StepTextProps, {}> {

    render() {
        const styles = this.getStyles();

        return (
            <div>
                {
                    this.props.showHelpIcon ?
                        <IconButton style={styles.helpButton}
                            iconStyle={styles.helpIcon}
                            onTouchTap={this.props.onHelp}
                            tooltip={l10n.getString('onboardingGuide.actions.help.tooltip') }
                            tooltipPosition="top-left"
                        ><ActionHelpOutline/></IconButton>
                        :
                        null
                }
                <div className="title" style={styles.title}>{this.props.title}</div>
                <div className="description" style={styles.description}>{this.props.description}</div>
            </div>
        );
    }

    private getStyles() {
        return {
            helpButton: {
                margin: "-4px 0 0 0",
                padding: 0,
                height: "24px",
                width: "24px",
                float: "right",
            },
            helpIcon: {
                color: 'rgba(0, 0, 0, 0.54)',
            },
            title: {
                fontWeight: 600,
                color: "#262e38",
                marginBottom: "11px"
            },
            description: {
                fontSize: "15px",
                fontWeight: "normal",
                lineHeight: "20px",
                color: "#262e38"
            } as React.CSSProperties,
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/StepText.tsx
 **/